import { render, staticRenderFns } from "./CardUspBox.vue?vue&type=template&id=d09220f2&scoped=true&"
import script from "./CardUspBox.vue?vue&type=script&lang=js&"
export * from "./CardUspBox.vue?vue&type=script&lang=js&"
import style0 from "./CardUspBox.vue?vue&type=style&index=0&id=d09220f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d09220f2",
  null
  
)

export default component.exports